// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
//引入mint-ui组件库
import Mint from 'mint-ui';
import 'mint-ui/lib/style.css'
Vue.use(Mint);
//引入jquery
import jQuery from 'jquery'
import req  from './api/request'
import go  from './go/go'
//引入插件
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
//引入字体资源
import zh from '../static/lang/zh'
import en from '../static/lang/en'
import zhtw from '../static/lang/zh-tw'
//实例化
const i18n = new VueI18n({
    locale: 'zh-tw',
    messages:{
        'zh': zh,
        'zh-tw': zhtw,
        'en': en,
    }
})
Vue.config.productionTip = false

Vue.prototype.$J = jQuery
Vue.prototype.req = req
Vue.prototype.go = go
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
    i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js